import { forwardRef } from "react";
import { Mail, MessageCircle } from "lucide-react";
import { CONTACT, BOOKING_BODY } from "@/lib/constants";
import { Reveal } from "./Reveal";
import { FloatingOrbs } from "./FloatingOrbs";

const mailto = `mailto:${CONTACT.email}?subject=${encodeURIComponent(
  "Booking Cosplay Singers — Richiesta spettacolo"
)}&body=${encodeURIComponent(
  "Buongiorno,\n\nvorremmo portare le Cosplay Singers al nostro evento.\n\nEvento:\nData:\nCittà / Location:\nReferente:\nContatto:\n\nGrazie."
)}`;

const whatsapp = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
  "Buongiorno! Vorremmo informazioni per portare le Cosplay Singers al nostro evento."
)}`;

export const Booking = forwardRef((props, ref) => (
  <section id="booking" ref={ref} className="px-5 sm:px-8 lg:px-12 py-24 sm:py-32" data-testid="booking">
    <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border border-white/70 px-6 sm:px-16 py-20 sm:py-28"
      style={{ background: "linear-gradient(135deg, #FBCFE8 0%, #D3EEFF 50%, #CFEFDD 100%)" }}>
      <FloatingOrbs />
      <Reveal className="relative z-10 text-center">
        <p className="mb-5 text-xs uppercase tracking-[0.3em] text-lavender-deep">Per direttori artistici & organizzatori</p>
        <h2 className="mx-auto max-w-3xl font-serif tracking-tightest text-4xl sm:text-6xl lg:text-7xl leading-[1.0] text-balance text-navy">
          Porta questa esperienza al tuo evento.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg sm:text-xl leading-relaxed text-navy-soft">{BOOKING_BODY}</p>

        <div className="mt-10 flex flex-col items-center justify-center sm:flex-row gap-4">
          <a data-testid="booking-email-btn" href={mailto}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-navy px-8 py-4 text-base font-medium text-white transition-transform duration-300 hover:scale-[1.03]">
            <Mail size={18} /> {CONTACT.email}
          </a>
          <a data-testid="booking-whatsapp-btn" href={whatsapp} target="_blank" rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full glass-strong px-8 py-4 text-base font-medium text-navy transition-colors duration-300 hover:text-lavender-deep">
            <MessageCircle size={18} /> WhatsApp {CONTACT.phoneDisplay}
          </a>
        </div>

        <p className="mt-8 text-sm text-navy-soft">Management — {CONTACT.management}</p>
      </Reveal>
    </div>
  </section>
));

Booking.displayName = "Booking";
